import { Component, Input, Output, EventEmitter } from '@angular/core';
import {Location} from '@angular/common';
import { ActivatedRoute, Router } from "@angular/router";
import * as _ from 'lodash';

@Component({
  selector: 'tr-navigation-button',
  templateUrl: './navigation-button.component.html',
  //styleUrls: ['./navigation-button.component.scss']
})
export class NavigationButtonComponent {
  @Input() prevText: string = 'Prev';
  @Input() prevButtonVisibility: boolean;
  @Input() nextButtonVisibility: boolean;
  @Input() saveButtonVisibility: boolean;
  @Input() nextButtonEnabled: boolean;
  @Input() nextText: string = 'Next';
  @Input() saveText: string = 'Save';
  @Input() currentId: number;
  @Input() pageLength: number;
  @Input() starter: boolean;
  @Output() buttonClick= new EventEmitter;

  constructor(private route: ActivatedRoute, private router:Router, private location: Location) {
    
  }

  isStarter() {
    return this.starter;
  }

  isNotPageOne() {
    if(this.currentId != 1) return true;
    return false;
  }

  onButtonClicked(shift: number, isDraft?: boolean) {
    if (shift < 0 && !this.prevButtonVisibility) return;
    this.buttonClick.emit({
      nextPage: this.currentId + shift,
      isDraft: isDraft ? isDraft : false
    });
  }

  gotoTasks(): void {
    this.location.back();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/navigation-button/navigation-button.component.ts